import { render } from "./OperationDetail.vue?vue&type=template&id=66072bfa&scoped=true"
import script from "./OperationDetail.js?vue&type=script&lang=js&external"
export * from "./OperationDetail.js?vue&type=script&lang=js&external"

import "./OperationDetail.scss?vue&type=style&index=0&id=66072bfa&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66072bfa"]])

export default __exports__